import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeAppInsights } from './appInsights';
import ErrorBoundary from './ErrorBoundary';
import { Provider } from 'react-redux';
import { store } from './store/store';

// Initialize Application Insights for telemetry tracking
initializeAppInsights();

// Suppress the benign ResizeObserver loop warning from CRA's dev overlay.
// This fires when Bootstrap's dynamic layout (e.g. h-100 cards resizing) causes
// a ResizeObserver callback to re-trigger before the current batch completes.
// It has no functional impact and is safe to ignore.
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
